// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lD0z","col":"styles_col__3CG_-"};